<template>
  <div class="d-flex flex-row justify-content-start align-items-start flex-wrap">
    <div class="form-container form-container-recherche-coureur">
      <div class="form-label">Rechercher un coureur</div>
      <b-form-input size="sm" class="bg-lightfield" v-model="$store.state.event.filters.keyword"
        placeholder="Rechercher un coureur par nom ou n° de dossard"></b-form-input>
    </div>
    <div class="form-container">
      <div class="form-label">Par sexe</div>
      <b-form-select size="sm" class="bg-lightfield" v-model="$store.state.event.filters.sexe"
        :options="optionsSexe"></b-form-select>
    </div>
    <div class="form-container">
      <div class="form-label">Par catégorie</div>
      <b-form-select size="sm" class="bg-lightfield" v-model="$store.state.event.filters.categorie"
        :options="$store.state.event.list_categories_filters"></b-form-select>
    </div>
    <div class="form-container">
      <div class="form-label">Par club</div>
      <b-form-select size="sm" class="bg-lightfield" v-model="$store.state.event.filters.club"
        :options="$store.state.event.list_club_filters"></b-form-select>
    </div>
    <div class="form-container">
      <div class="form-label">Télécharger cette sélection</div>
      <DownloadSelectionSection></DownloadSelectionSection>

    </div>

  </div>
</template>

<script>
import DownloadSelectionSection from './DownloadSelectionSection.vue';


export default {
  name: 'FiltersResultsBar',
  components: {
    DownloadSelectionSection,
  },
    data() {
      return {
        optionsSexe: [
          { value: '', text: 'Tous' },
          { value: 'M', text: 'Homme' },
          { value: 'F', text: 'Femme' },
          { value: 'X', text: 'Mixte' },
        ],
      }
    },

};
</script>

<style scoped>

</style>
